import { render, staticRenderFns } from "./AnalyticDetail.vue?vue&type=template&id=95eae3f8&scoped=true&"
import script from "./AnalyticDetail.vue?vue&type=script&lang=js&"
export * from "./AnalyticDetail.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticDetail.vue?vue&type=style&index=0&id=95eae3f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95eae3f8",
  null
  
)

export default component.exports